import produce from 'immer';
import {
  SET_WORKLIST,
  SET_CREDIT_REQUEST_BY_WORKLIST,
  SET_EMPLOYEES,
  SET_WORKLIST_STATUS_TYPES,
  SET_WORKLIST_ERROR,
  SET_IS_WORKLIST_ERROR,
} from './constants';

export const initialState = {
  workList: { data: [] },
  employees: { data: [] },
  creditRequests: [],
  worklistStatusList: [],
  worklistError: '',
  isWorklistError: false,
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_WORKLIST:
        draft.workList = payload;
        draft.creditRequests = [];
        break;
      case SET_CREDIT_REQUEST_BY_WORKLIST:
        draft.creditRequests = payload;
        break;
      case SET_EMPLOYEES:
        draft.employees = payload;
        draft.creditRequests = [];
        break;
      case SET_WORKLIST_STATUS_TYPES:
        draft.worklistStatusList = payload;
        break;
      case SET_WORKLIST_ERROR:
        draft.worklistError = payload;
        break;
      case SET_IS_WORKLIST_ERROR:
        draft.isWorklistError = payload;
        break;
      default: {
        break;
      }
    }
  });

export default reducer;
